export default __webpack_public_path__ + "static/media/640_business03-jp-web.5da04e17.png";